import { useLang } from 'hooks/lang';

import { Column, Row } from 'components/Blocks';

import { InvoiceWrapper } from '../Wrapper';
import { SentToInvoice } from './SentToInvoice';
import { PaymentMethod } from './PaymentMethod';

export function WaitingInvoiceInfo() {
  const { t } = useLang();

  return (
    <InvoiceWrapper>
      <Column justifyContent="center" alignItems="center" gap="10" className="min-h-[45vh]">
        <span className="font-semibold">{t('we-still-need-more-information')}</span>

        <Row justifyContent="center" alignItems="stretch" className="tablet:flex-col">
          <SentToInvoice />

          <PaymentMethod />
        </Row>
      </Column>
    </InvoiceWrapper>
  );
}
